import { SET_SAVE_FUNCTION, GET_HEIGHT, SHOW_MENU, SHOW_ORDER_MANAGEMENT, NAVIGATION, HEADER_NAV } from './types'
export const nav = (nav: any) => {
  return {
    type: NAVIGATION,
    payload: nav
  }
}
export const getHeight = (height: any) => {
  return {
    type: GET_HEIGHT,
    payload: height
  }
}

export const showOrderManagement = (show: any) => {
  return {
    type: SHOW_ORDER_MANAGEMENT,
    payload: show
  }
}

export const showMenu = () => {
  return {
    type: SHOW_MENU
  }
}

export const headerNav = (headerNav: any) => {
  return {
    type: HEADER_NAV,
    payload: headerNav
  }
}

export const setSaveFunction = (saveFunction: any) => {
  return {
    type: SET_SAVE_FUNCTION,
    payload: saveFunction
  }
}